import { Modal } from '@frontend/design-system';
import { CardOnFileDefaultActions } from '../../card-on-file/default/default-actions';
import { PaymentMethodsViewSwitch } from '../atoms/payment-methods-view-switch';
import { PaymentMethodsDefaultAchActions } from './default-ach-actions';
import { PaymentMethodsDefaultListActions } from './default-list-actions';

export const DefaultActionsFooter = () => {
  return (
    <Modal.Footer>
      <PaymentMethodsViewSwitch view='list'>
        <PaymentMethodsDefaultListActions shouldUsePadding={false} />
      </PaymentMethodsViewSwitch>

      <PaymentMethodsViewSwitch view='add-card'>
        <CardOnFileDefaultActions shouldUsePadding={false} />
      </PaymentMethodsViewSwitch>

      <PaymentMethodsViewSwitch view='add-ach'>
        <PaymentMethodsDefaultAchActions shouldUsePadding={false} />
      </PaymentMethodsViewSwitch>
    </Modal.Footer>
  );
};
